import React from 'react';
import { withRouter } from "react-router";
import GeneralForm from "../accounting/GeneralForm";

const BillsForm = () => <GeneralForm name={"bills"} singularName={"bill"}/>

export default withRouter(BillsForm)
